import { createContext } from 'react';

export const FilterDialogContext = createContext(false);
